import _sfc_main from "./indexH5.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.showSideBar ? _c(_setup.popup, { staticClass: "sidebar-container-mobile", attrs: { "title": _setup.title }, scopedSlots: _vm._u([{ key: "sidebarContent", fn: function() {
    return [_c("div", { staticStyle: { "height": "100%" } }, [_setup.sidebarName === "chat" ? _c(_setup.Chat) : _vm._e(), _setup.sidebarName === "manage-member" ? _c(_setup.ManageMember) : _vm._e(), _setup.sidebarName === "apply" ? _c(_setup.MasterApply) : _vm._e()], 1)];
  }, proxy: true }, { key: "sidebarFooter", fn: function() {
    return [_c("div", [_setup.sidebarName === "chat" ? _c(_setup.ChatEditor) : _vm._e()], 1)];
  }, proxy: true }], null, false, 4065015165) }) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "17af241e"
);
const indexH5 = __component__.exports;
export {
  indexH5 as default
};
